<template>
  <div class="page-container">
    <div class="row ml-1">
      <h4 class="mb-4 mr-2">Lista administratorów</h4>
      <div>
        <b-button size="sm" @click="addAdmin">
          <span data-feather="plus"></span>
          Dodaj konto administratora
        </b-button>
      </div>
    </div>
    <b-table
      :items="items"
      :fields="fields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      show-empty
      stacked="md"
      :current-page="currentPage"
      :per-page="perPage"
      empty-text="Brak użytkowników"
    >
      <template v-slot:cell(blocked)="row">
        <div>
          <span v-if="row.item.blocked === 0">Tak</span>
          <span v-else>Nie</span>
        </div>
      </template>
      <template v-slot:cell(actions)="row">
        <b-button-group>
          <b-button class="btn-primary mr-1" size="sm" @click="editAdmin(row)">Edycja</b-button>
          <b-button class="btn-danger" size="sm" @click="deleteAdmin(row)">Usuń</b-button>
        </b-button-group>
      </template>
    </b-table>
    <b-row>
      <b-col md="12" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'Doctors',
  mounted() {
    const vm = this
    vm.listAdmins()
  },
  data() {
    return {
      sortBy: 'name',
      sortDesc: false,
      fields: [
        { key: 'name', label: 'Imię', sortable: true },
        { key: 'lastname', label: 'Nazwisko', sortable: true },
        { key: 'email', label: 'Email', sortable: true },
        { key: 'account_type', label: 'Typ konta', sortable: true },
        { key: 'blocked', label: 'Aktywny', sortable: true },
        { key: 'actions', label: 'Akcje' }
      ],
      items: [],
      currentPage: 1,
      totalRows: 0,
      perPage: 10
    }
  },
  watch: {
    items() {
      this.updateUI()
    }
  },
  methods: {
    listAdmins() {
      const vm = this
      vm.$store.commit('addPageLoaderEvent', 'listDoctors')
      vm.$http.get('e-zacma/admin').then(response => {
        vm.items = response.data
        vm.$store.commit('removePageLoaderEvent', 'listDoctors')
      })
    },
    editAdmin(row) {
      this.$router.push({ name: 'admin-edit', params: { id: row.item.id } })
    },
    deleteAdmin(row) {
      const vm = this
      vm.$bvModal
        .msgBoxConfirm(
          `Czy na pewno chcesz usunąć administratora "${row.item.name} ${row.item.lastname}". Wynik tej operacji jest permanentny.`,
          {
            okVariant: 'danger',
            okTitle: 'Tak',
            cancelTitle: 'Nie',
            hideHeaderClose: false,
            centered: true
          }
        )
        .then(decision => {
          if (decision) {
            vm.$store.commit('addPageLoaderEvent', 'delete-administrator')
            // eslint-disable-next-line camelcase
            const { id } = row.item
            // eslint-disable-next-line camelcase
            vm.$http
              .delete(`e-zacma/admin/${id}`)
              .then(() => {
                vm.listAdmins()
                vm.$toast.success({
                  message: `Konto "${row.item.name}" zostało skasowane.`
                })
              })
              .catch(e => vm.$error())
              .finally(() => {
                vm.$store.commit('removePageLoaderEvent', 'delete-administrator')
              })
          }
        })
    },
    addAdmin() {
      this.$router.push({ name: 'admin-create' })
    },
    updateUI() {
      this.totalRows = this.items.length
    }
  }
}
</script>

<style scoped></style>
